import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/agendamento`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create(id, queryParms) {
            return repository.get(`${baseUrl}/create/${id}?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        cancel(id, params) {
            return repository.put(`${baseUrl}/${id}/cancel`, params)
        },
        unidadePaciente(pacienteId, infraestruturaId) {
            return repository.get(`${baseUrl}/unidade-paciente/${pacienteId}/${infraestruturaId}`)
        },
        sugestao(pacienteId, infraestruturaId, ocupacaoId, especialidadeId, usuarioId, params = {}) {
            return repository.get(`${baseUrl}/sugestao/${pacienteId}/${infraestruturaId}/${ocupacaoId}/${especialidadeId}/${usuarioId}?${urlUtil.serialize(params)}`)
        },
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        absent(id) {
            return repository.put(`${baseUrl}/${id}/absent`)
        },
        undoAbsent(id) {
            return repository.put(`${baseUrl}/${id}/undo-absent`)
        },
        createAgendamentoDemandaEspontanea(pacienteId) {
            return repository.get(`${baseUrl}/create-agendamento-demanda-espontanea/${pacienteId}`)
        },
        getAgendamentosDemandasEspontaneas(params) {
            return repository.get(`${baseUrl}/agendamento-demanda-espontanea?${urlUtil.serialize(params)}`)
        },
    }
}